export default __webpack_public_path__ + "static/media/387.2aabf3e0.jpg";